export interface GenerationError {
    key: AudioError | TextError;
    title: string;
}

export type AudioError = 'language' | 'long-duration' | 'text-limit' | 'unauthorized' | 'no-connection' | 'unknown';

export const ttsGenerationErrors: Record<AudioError, GenerationError> = {
    language: {
        key: 'language',
        title: 'Invalid text for the selected language',
    },
    'long-duration': {
        key: 'long-duration',
        title: 'Audio duration is too long',
    },
    'text-limit': {
        key: 'text-limit',
        title: 'Character limit reached',
    },
    'no-connection': {
        key: 'no-connection',
        title: 'Connection error, please check your internet connection and try again.',
    },
    unauthorized: {
        key: 'unauthorized',
        title: 'Connection error, please check your internet connection and try again.',
    },
    unknown: {
        key: 'unknown',
        title: 'Something went wrong. Please try again.',
    },
};

export const convertErrorToAudioError = (error: any) => {
    const e = error as unknown as AudioError;
    return ttsGenerationErrors[e] ? e : 'unknown';
};

export type TextError = 'promptLength' | 'credits' | 'minutes' | 'empty';
